import type { API } from 'chessboard/api/config/types';
import type { Board } from 'chessboard/model/board/types';
import type { Core } from 'chessboard/core/config/types';
import { createKeyedHighlight } from 'chessboard/plugins/highlights/model/create-keyed-highlight';
import { getHighlightColorFromKeyPressed } from 'chessboard/plugins/highlights/modules/analysis/get-highlight-color-from-key-pressed';
import type { KeyedHighlight } from 'chessboard/plugins/highlights/config/types';
import { HighlightType } from 'chessboard/plugins/highlights/config/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';

/**
 * Adds analysis highlights to the event. This should be the last highlight middleware
 * before the final "highlights" middleware because if these are set they will override
 * all other types (move highlights, selection square, etc.).
 */
export function getAnalysisHighlights(_event: Core.Event, context: Core.Context): KeyedHighlight[] {
  const { api, options }: { api: API.ExtendedAPI; options: Board.Options } = context;

  if (!options || !options.allowMarkings) {
    return [];
  }

  return (<Markings.API>api.markings)
    .getAllWhere({ types: [HighlightType] })
    .map(({ data: { color, keyPressed, opacity, square } }) =>
      createKeyedHighlight({
        color:
          getHighlightColorFromKeyPressed(keyPressed, options) ??
          color ??
          options.analysisHighlightColors.default,
        opacity: opacity ?? options.analysisHighlightOpacity,
        square,
        type: 'analysis',
      }),
    );
}
